// extracted by mini-css-extract-plugin
export default {"vehicleDetails":"VehicleDetails_vehicleDetails__zEQWJ","vehicleDetails_2":"VehicleDetails_vehicleDetails_2__fqKxQ"};